/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";



export const GroupSettingActionsColumnFormatter = (
    cellContent,
    row,
    rowIndex,
    {
        openAttendenceSettingPage, accessAttendence,
        openCullinanSettingPage, accessCullinan,
        openDormSettingPage, accessDorm,
        openSportSettingPage, accessSport,
    }
) => (
    <>
        {accessAttendence &&
            <OverlayTrigger
                overlay={<Tooltip id="objects-edit-tooltip">تنظیمات حضور غیاب</Tooltip>}
            >
                <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => openAttendenceSettingPage(row.id)}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")}
                        />
                    </span>
                </a>
            </OverlayTrigger>}
        <> </>

        {accessCullinan &&
            <OverlayTrigger
                overlay={<Tooltip id="objects-edit-tooltip">تنظیمات تغذیه</Tooltip>}
            >
                <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => openCullinanSettingPage(row.id)}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            src={toAbsoluteUrl("/media/svg/icons/Cooking/Chef.svg")}
                        />
                    </span>
                </a>
            </OverlayTrigger>}

        <> </>

        {accessSport &&
            <OverlayTrigger
                overlay={<Tooltip id="objects-edit-tooltip">تنظیمات سرای</Tooltip>}
            >
                <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => openDormSettingPage(row.id)}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            src={toAbsoluteUrl("/media/svg/icons/Home/Bed.svg")}
                        />
                    </span>
                </a>
            </OverlayTrigger>}
        <> </>

        {accessDorm &&
            <OverlayTrigger
                overlay={<Tooltip id="objects-edit-tooltip">تنظیمات ورزشی</Tooltip>}
            >
                <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => openSportSettingPage(row.id)}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            src={toAbsoluteUrl("/media/svg/icons/Clothes/T-Shirt.svg")}
                        />
                    </span>
                </a>
            </OverlayTrigger>}

    </>
);
